import isEnterpriseEnv from './isEnterpriseEnv';

export default isEnterpriseEnv;
